import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseButton from "../../components/ui/BaseButton";
import AddEditTaskModal from "./components/AddEditTaskModal";
import { useState } from "react";

const TaskBoardListingHeader = ({
  isAddEditTaskModal,
  setIsAddEditTaskModal,
  refetchAllTeamTask,
  setSelectedTask,
  selectedTask,
  setTasksList,
  authUserTeams,
  isCompanyOwner,
  authUser,
}) => {
  return (
    <div className="border-b border-zinc-300 bg-white ">
      <BaseWrapper>
        <div className="grid grid-cols-7 gap-y-3 py-[7px] items-center">
          <div className="md:col-span-2 col-span-7">
            <h3 className="font-light md:text-left text-center">Task Board</h3>
          </div>
          <div className="md:col-span-5 col-span-7 gap-x-4 flex  justify-end">
            <BaseButton
              className="md:w-auto  py-[6px] px-[12px]"
              // fullWidth={true}
              variant="contained"
              color="primary"
              onClick={() => setIsAddEditTaskModal(true)}
            >
              Create New Task
            </BaseButton>
          </div>
        </div>
      </BaseWrapper>

      {isAddEditTaskModal && (
        <AddEditTaskModal
          isAddEditTaskModal={isAddEditTaskModal}
          setIsAddEditTaskModal={setIsAddEditTaskModal}
          refetchAllTeamTask={refetchAllTeamTask}
          setSelectedTask={setSelectedTask}
          selectedTask={selectedTask}
          setTasksList={setTasksList}
          authUserTeams={authUserTeams}
          isCompanyOwner={isCompanyOwner}
          authUser={authUser}
        />
      )}
    </div>
  );
};

export default TaskBoardListingHeader;
